import React from "react"
import clsx from "clsx"

import { Asset, Breadcrumb } from "components"

export default function WideHero({jobTitle}) {
  return (
    <header
      className={clsx(
        "default-grid pb-24 pt-24 bg-darkPurple"
      )}
    >
      <div className="space-y-6 jdWrapper col-span-full">
        <Breadcrumb
          label="Join the Hearthside Team"
          href="/careers"
          appearance="secondary"
        />
        <h1  className="text-white h2">{jobTitle}</h1>
      </div>
    </header>
  )
}
